/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  L1CustomGateway,
  L1CustomGatewayInterface,
} from "../../../../contracts/ethereum/gateway/L1CustomGateway";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "l1Token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_sequenceNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "DepositInitiated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "l1Address",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "l2Address",
        type: "address",
      },
    ],
    name: "TokenSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_seqNum",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "TxToL2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exitNum",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newData",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "madeExternalCall",
        type: "bool",
      },
    ],
    name: "WithdrawRedirected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "l1Token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_exitNum",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "WithdrawalFinalized",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "l1ERC721",
        type: "address",
      },
    ],
    name: "calculateL2TokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "counterpartGateway",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exitNum",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_initialDestination",
        type: "address",
      },
    ],
    name: "encodeWithdrawal",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "finalizeInboundTransfer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_l1Addresses",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_l2Addresses",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_maxGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_gasPriceBid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxSubmissionCost",
        type: "uint256",
      },
    ],
    name: "forceRegisterTokenToL2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exitNum",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_initialDestination",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_initialData",
        type: "bytes",
      },
    ],
    name: "getExternalCall",
    outputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_tokendata",
        type: "bytes",
      },
    ],
    name: "getOutboundCalldata",
    outputs: [
      {
        internalType: "bytes",
        name: "outboundCalldata",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inbox",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Counterpart",
        type: "address",
      },
      {
        internalType: "address",
        name: "_l1Router",
        type: "address",
      },
      {
        internalType: "address",
        name: "_inbox",
        type: "address",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "l1ToL2Token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_gasPriceBid",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "outboundTransfer",
    outputs: [
      {
        internalType: "bytes",
        name: "res",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_refundTo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_gasPriceBid",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "outboundTransferCustomRefund",
    outputs: [
      {
        internalType: "bytes",
        name: "res",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "postUpgradeInit",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "redirectedExits",
    outputs: [
      {
        internalType: "bool",
        name: "isExit",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_newTo",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_newData",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l2Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_gasPriceBid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxSubmissionCost",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_creditBackAddress",
        type: "address",
      },
    ],
    name: "registerTokenToL2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l2Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_gasPriceBid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxSubmissionCost",
        type: "uint256",
      },
    ],
    name: "registerTokenToL2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exitNum",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_initialDestination",
        type: "address",
      },
      {
        internalType: "address",
        name: "_newDestination",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_newData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "transferExitAndCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "whitelist",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type L1CustomGatewayConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: L1CustomGatewayConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class L1CustomGateway__factory extends ContractFactory {
  constructor(...args: L1CustomGatewayConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<L1CustomGateway> {
    return super.deploy(overrides || {}) as Promise<L1CustomGateway>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): L1CustomGateway {
    return super.attach(address) as L1CustomGateway;
  }
  override connect(signer: Signer): L1CustomGateway__factory {
    return super.connect(signer) as L1CustomGateway__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): L1CustomGatewayInterface {
    return new utils.Interface(_abi) as L1CustomGatewayInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): L1CustomGateway {
    return new Contract(address, _abi, signerOrProvider) as L1CustomGateway;
  }
}
